import type { EarnedData, RewardData } from "shared/schema";
import { useState } from "react";
import { Icon } from "shared/react";
import { renderMarkup } from "shared/schema";
import { formatCompactNumber } from "shared/util/number";
import { RawBackgroundIcon } from "./BackgroundIcon.js";
import { RawRewardIcon } from "./RewardIcon.js";

export function RewardInteractiveIcon({ reward, earned }: { reward: RewardData; earned?: EarnedData | undefined }): React.ReactElement {
	const { secret, type } = reward;
	const [flipped, setFlipped] = useState(false);
	const mods = type === "background" ? "background size-8x" : "icon size-12x";
	const image = type === "background" ? <RawBackgroundIcon {...reward} mods={mods} /> : <RawRewardIcon {...reward} mods={mods} />;
	if (!earned) return image;
	return (
		<button type="button" className="space-none pin-container" onClick={() => setFlipped(!flipped)}>
			<figure className={`space-none flip-front animate-slow ${mods} ${flipped ? "flipped" : ""}`}>
				{image}
				<data className={`badge badge-success size-large pin-right pin-bottom`}>{type === "badge" ? formatCompactNumber(earned.count) : <Icon icon="tick" />}</data>
			</figure>
			<figure className={`size-large face-serif pin-cover flex-row flex-center flex-middle flip-back animate-slow ${flipped ? "flipped" : ""}`}>{secret ? renderMarkup(secret) : <p>Nice!</p>}</figure>
		</button>
	);
}
